import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@core/store/store'

const toast = (state: RootState) => state.toastReducer
export const toastSelector = createSelector(
  toast,
  toastReducer => toastReducer.toast,
)
